import { SEC_TYPE } from 'const/stock'
import getOptionExpiryString from './getOptionExpiryString'

// 获取标的代码
export default function getLocalSymbol(stock) {
  if (stock.secType === SEC_TYPE.OPT) {
    return `${stock.symbol} ${getOptionExpiryString(stock.expiry)} ${
      stock.strike
    } ${stock.right.toUpperCase()}`
  }
  return stock.symbol
}
